import { render } from "./UserStatement.vue?vue&type=template&id=46b127bc"
import script from "./UserStatement.vue?vue&type=script&lang=js"
export * from "./UserStatement.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__